export interface CategoryNode {
  id: string;
  label: string;
  children?: CategoryNode[];
  value?: string;
  disabled?: boolean;
  checkable?: boolean;
}

export interface FindResult {
  node: CategoryNode | null;
  parent: CategoryNode | null;
}

// 自動判斷葉節點
export function isLeafNode(node: CategoryNode): boolean {
  return !node.children || node.children.length === 0;
}

/** 遍歷整棵樹，找 id 對應的 node 和它的 parent */
export function findNode(
  nodes: CategoryNode[],
  id: string,
  parent: CategoryNode | null = null,
): FindResult {
  for (const node of nodes) {
    if (node.id === id) {
      return { node, parent };
    }
    if (node.children) {
      const res = findNode(node.children, id, node);
      if (res.node) return res;
    }
  }
  return { node: null, parent: null };
}

/** 遍歷 node（含自身）往下呼叫 callback，可做 add/delete、收集等 */
export function traverseSubtree(
  node: CategoryNode,
  callback: (n: CategoryNode) => void,
) {
  callback(node);
  node.children?.forEach((child) => traverseSubtree(child, callback));
}

/** 收集節點 */
export function collectNodes(
  nodes: CategoryNode[],
  mode: 'leaf' | 'nonLeaf',
  returnType: 'node' | 'id',
): (CategoryNode | string)[] {
  let result: (CategoryNode | string)[] = [];
  for (const node of nodes) {
    const isLeaf = isLeafNode(node);
    if ((mode === 'leaf' && isLeaf) || (mode === 'nonLeaf' && !isLeaf)) {
      result.push(returnType === 'node' ? node : node.id);
    }
    if (node.children) {
      result = result.concat(collectNodes(node.children, mode, returnType));
    }
  }
  return result;
}

/** 檢查以 root 為根的子樹，所有 leaf id 都在 selectedSet 裡 */
export function isSubtreeFullySelected(
  root: CategoryNode,
  selectedSet: Set<string>,
): boolean {
  const leafIds = collectNodes([root], 'leaf', 'id') as string[];
  return leafIds.length > 0 && leafIds.every((id) => selectedSet.has(id));
}
